module.exports = "{{ TermDisplayCtrl.displayTerm }}\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/data-presentation/term-display/term-display.html
// module id = 532
// module chunks = 0